import script from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationItem.vue?vue&type=style&index=0&id=28277796&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28277796"]])

export default __exports__